import React, { useContext, useEffect, useState } from "react";
import { Image, Pressable, ScrollView, StyleSheet, View } from "react-native";
import { useRoute } from "@react-navigation/native";
import Icon from "react-native-vector-icons/Ionicons";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PlaceColors } from "./helpers/PlaceColors";
import { PlaceText } from "./components/PlaceText";
import { IconShadow } from "./helpers/DefaultShadows";

export const GallerySlidePage = ({ navigation, ...props }: any) => {
    const router: any = useRoute();
    const [images, setImages] = useState([]);
    const insets = useSafeAreaInsets();
    const [currentImage, setCurrentImage] = useState(0);
    const findifyDataContext = useContext(FindifyDataContext);

    useEffect(() => {
        if (router?.params) {
            const images = (router.params['images'] ?? []).filter(Boolean);
            setImages(images);
            const currentImage = router.params['currentImage'];
            setCurrentImage(Math.max(0, Math.min(images.length - 1, currentImage ?? 0)));
        }
    }, []);

    const goToImage = (direction: -1 | 1) => {
        setCurrentImage((current) => Math.max(0, Math.min(images.length - 1, current + direction)));
    }

    const imageUri = images[currentImage];

    return <View>
        <View
            style={{
                width: '100%',
                height: '100%',
                backgroundColor: PlaceColors(findifyDataContext).background.get(),
            }}
        >
            {imageUri ? (
                <ScrollView
                    style={styles.imageScroll}
                    contentContainerStyle={styles.imageScrollContent}
                    maximumZoomScale={4}
                    minimumZoomScale={1}
                    showsHorizontalScrollIndicator={false}
                    showsVerticalScrollIndicator={false}>
                    <Image
                        source={{ uri: imageUri }}
                        resizeMode="contain"
                        style={styles.image}
                    />
                </ScrollView>
            ) : null}

            <Icon style={[{ color: PlaceColors(findifyDataContext).text.get(), position: 'absolute', top: insets.top, left: 0 }, styles.headerIcon]} name="chevron-back" size={30} color="white" onPress={() => {
                navigation?.goBack();
            }} />
            {currentImage > 0 ? (
                <Pressable style={[styles.navButton, styles.navButtonLeft]} onPress={() => goToImage(-1)}>
                    <Icon name="chevron-back" size={34} color={PlaceColors(findifyDataContext).text.get()} />
                </Pressable>
            ) : null}
            {currentImage < images.length - 1 ? (
                <Pressable style={[styles.navButton, styles.navButtonRight]} onPress={() => goToImage(1)}>
                    <Icon name="chevron-forward" size={34} color={PlaceColors(findifyDataContext).text.get()} />
                </Pressable>
            ) : null}
            <PlaceText style={[{
                position: 'absolute',
                top: insets.top + 10,
                right: 0,
                color: PlaceColors(findifyDataContext).text.get()
            }, styles.headerIcon]}>{currentImage + 1} / {images.length}</PlaceText>
            <Pressable
                onPress={() => navigation.pop()}>
                {/* <PlaceText>Close</PlaceText> */}
            </Pressable>
        </View>
    </View>;
};


const styles = StyleSheet.create({
    imageScroll: {
        width: '100%',
        height: '100%',
    },
    imageScrollContent: {
        width: '100%',
        minHeight: '100%' as any,
        alignItems: 'center',
        justifyContent: 'center',
    },
    image: {
        width: '100%',
        height: '100%',
        minHeight: 420,
    },
    navButton: {
        position: 'absolute',
        top: '50%' as any,
        width: 48,
        height: 48,
        marginTop: -24,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255,255,255,0.72)',
        borderRadius: 24,
    },
    navButtonLeft: {
        left: 12,
    },
    navButtonRight: {
        right: 12,
    },
    headerIcon: {
        padding: 5,
        ...IconShadow
    }
});
